/**
 * The above functions are used to make API calls related to leads, including getting, creating,
 * updating, and deleting leads.
 * @returns These functions are returning promises that make API calls using the `apiClient` to perform
 * operations such as getting leads, creating a lead, updating a lead, and deleting a lead.
 */
import apiClient from '../apiClient';

// Leads API calls

export const getLeads = () => {
  return apiClient.get('/leads');
};

export const getLeadsWithAuth = (username, password, params) => {
  return apiClient.get('/api/leads', {
    auth: { username, password },
    params,
  });
};

export const createLead = (leadData) => {
  return apiClient.post('/leads', leadData);
};

export const updateLead = (leadId, leadData) => {
  return apiClient.put(`/leads/${leadId}`, leadData);
};

export const deleteLead = (leadId) => {
  return apiClient.delete(`/leads/${leadId}`);
};
